import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiRequest } from "../_helpers/apiConfig";


export const getCertificateList = createAsyncThunk("/course/certificateList", async (filters) => {
  const response = await apiRequest('POST', 'v1/course/certificateList', filters);
  return response;
});

export const getCertificateStatus = createAsyncThunk("/course/updateCertificateStatus",
  async (arg, thunkAPI) => {
    const { payload, filter } = arg;
    const response = await apiRequest('POST', 'v1/course/updateCertificateStatus', payload);
    if (response.message) {
      thunkAPI.dispatch(getCertificateList(filter));
    }
    return response;
  });

export const previewCertificate = createAsyncThunk("/course/previewCertificate",
  async (arg, thunkAPI) => {
    const { payload, filter } = arg;
    const response = await apiRequest('get', `v1/course/previewCertificate?fileName=${payload}`);
    if (response.message) {
      thunkAPI.dispatch(getCertificateList(filter));
    }
    return response;
  });




export const createAppSettings = createAsyncThunk("/course/createAppSetting",
  async (arg, thunkAPI) => {
    const { payload, filter } = arg;
    const response = await apiRequest("POST", "v1/course/createAppSetting", payload);
    if (response.message) {
      thunkAPI.dispatch(getCertificateList(filter));
    }
    return response;
  }
);

export const updateAppSettings = createAsyncThunk("/course/updateAppSetting",
  async (arg, thunkAPI) => {
    const { Payload, forReferesh } = arg;
    const response = await apiRequest("POST", "v1/course/updateAppSetting", Payload);
    if (response.message) {
      thunkAPI.dispatch(getCertificateList(forReferesh));
    }
    return response;
  }
);


export const updateAppSettingsStatus = createAsyncThunk("/course/updateAppSettingStatus",
  async (arg, thunkAPI) => {
    const { Payload, forReferesh } = arg;
    const response = await apiRequest("POST", "v1/course/updateAppSettingStatus", Payload);
    if (response.message) {
      thunkAPI.dispatch(getCertificateList(forReferesh));
    }
    return response;
  }
);



export const deleteAppSetting = createAsyncThunk("/course/deleteAppSetting",
  async (arg, thunkAPI) => {
    const { Payload, forReferesh } = arg;
    const response = await apiRequest("POST", "v1/course/deleteAppSetting", Payload);
    if (response.message) {
      thunkAPI.dispatch(getCertificateList(forReferesh));
    }
    return response;
  }
);



const appSettingsSlice = createSlice({
  name: 'appSettings',
  initialState: {
    getAllAppSettings: {},
    latestSignUp: [],
    total: null,
    loading: false,
    error: null,
    deleteAppSetting: null,
    responsedata: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCertificateList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCertificateList.fulfilled, (state, action) => {
        state.loading = false;
        state.getList = action?.payload?.data;
      })
      .addCase(getCertificateList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(getCertificateStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCertificateStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.responsedata = action?.payload?.data;
      })
      .addCase(getCertificateStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })



      .addCase(previewCertificate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(previewCertificate.fulfilled, (state, action) => {
        state.loading = false;
        // state.getList = action?.payload?.data;
      })
      .addCase(previewCertificate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })







      .addCase(createAppSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createAppSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.cretaeAppSetting = action?.payload;
      })
      .addCase(createAppSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })


      .addCase(updateAppSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateAppSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.updateAppSetting = action?.payload;
      })
      .addCase(updateAppSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })


      .addCase(updateAppSettingsStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateAppSettingsStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.updateStatusAppSetting = action?.payload;
      })
      .addCase(updateAppSettingsStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(deleteAppSetting.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteAppSetting.fulfilled, (state, action) => {
        state.loading = false;
        state.deleteAppSetting = action?.payload;
      })
      .addCase(deleteAppSetting.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })










  },
});

export default appSettingsSlice.reducer